import RecommendationList from "./RecommendationList";

export default RecommendationList;
